// extracted by mini-css-extract-plugin
export default {"info":"InputDetail-module__info__KZT0e","count":"InputDetail-module__count__w9S73","help":"InputDetail-module__help___rUmT","error":"InputDetail-module__error__c9mZR"};